// removed by extract-text-webpack-plugin
module.exports = {"main":"jFLFQPauRtmz3SLf64IyY"};


//////////////////
// WEBPACK FOOTER
// ./components/ForgotError.module.css
// module id = 2355
// module chunks = 1